
import { useState } from "react";
import { Box, Button, } from "@mui/material";

import OrderQuote from "./OrderQuote";
import PartnerOrderQuote from "./PartnerOrderQuote";


export default function SpotGoldQueries() {
  const [activeTab, setActiveTab] = useState("OrderQuote");
  return (
    <>
      <Box>
        <Box display="flex" justifyContent="center" mb={2}>
          <Button
            variant={
              activeTab === "OrderQuote"
                ? "contained"
                : "outlined"
            }
            onClick={() => setActiveTab("OrderQuote")}
            sx={{ marginRight: 2 }}
          >
            Order Quote
          </Button>
          <Button
            variant={
              activeTab === "PartnerOrderQuote" ? "contained" : "outlined"
            }
            onClick={() => setActiveTab("PartnerOrderQuote")}
          >
            Partner Order Quote
          </Button>
        </Box>

        {/* Conditionally render content based on activeTab */}
        {activeTab === "OrderQuote" && (
          <Box>
            <OrderQuote />
          </Box>
        )}
        {activeTab === "PartnerOrderQuote" && (
          <Box>
            <PartnerOrderQuote />
          </Box>
        )}
      </Box>


    </>
  );
}
